var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKotlinOriginal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 500.003,
    x2: -0.097,
    y1: 579.106,
    y2: 1079.206,
    gradientTransform: "translate(15.534 -96.774) scale(.1939)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#e44857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#c711e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7f52ff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M112.484 112.484H15.516V15.516h96.968L64 64Zm0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKotlinOriginal);
export default __webpack_public_path__ + "static/media/kotlin-original.972dbf58257be1962e7953347f780377.svg";
export { ForwardRef as ReactComponent };